import { Profile } from "../models";
import { fetchAuthenticated } from "../scripts/custom-fetch";

export async function getProfiles() {
  const response = await fetchAuthenticated(`${process.env.REACT_APP_API_GET}/profiles`);

  if (!response.ok) {
    throw new Error(await response.json());
  }

  const profiles = await response.json();
  return profiles.map((profile: any) => ({
    id: profile.id,
    name: profile.name,
    profileName: profile.channelName,
    profilePictureUrl: profile.pic
  })) as Profile[];
}
